import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { PromiseStatuses } from "../../../../utils"
import {NewProductiveUnitService} from './dataService/service'
import { filtersDTO, NotUPResponseDTO, NotUpUpdateDTO } from "./dataService/dto"

interface NotificationProductiveUnitState {
    onEdit: boolean
    GetAllUpRowsResponse?: NotUPResponseDTO
    UpUpdateRequest: NotUpUpdateDTO
    getAllUpRowsStatus: PromiseStatuses
    UpdateUpStatus: PromiseStatuses
    filtersUp: filtersDTO
}

const initialState: NotificationProductiveUnitState = {
    onEdit: false,
    getAllUpRowsStatus: 'idle',
    UpdateUpStatus: 'idle',
    UpUpdateRequest: {},
    filtersUp: {
        page: 0,
        itemsPerPage: 0
    }
}

export const GetAllUpRows = createAsyncThunk(
    'Not/GetAllUpRows',
    async (filters: filtersDTO, thunkApi): Promise<NotUPResponseDTO> => {
        const NotProductiveUnitService = NewProductiveUnitService()
        return NotProductiveUnitService.GetAllProductiveUnit(filters).catch(error => {
            throw (thunkApi.rejectWithValue(error))
        })
    },
)


export const UpdateUp = createAsyncThunk(
    'Not/UpdateUp',
    async (request: {body: NotUpUpdateDTO, id: string}, thunkApi): Promise<void> => {
        const NotProductiveUnitService = NewProductiveUnitService()
        return NotProductiveUnitService.UpdateUp(request.body, request.id).catch(error => {
            throw (thunkApi.rejectWithValue(error))
        })
    },
)

const NotificationLivestockSlice = createSlice({
    name: 'notificationLivestock/slice',
    initialState,
    reducers: {
        setOnEdit: (state, action) => {
            state.onEdit = action.payload
        },
        //edit Up
        setUpZipCode: (state, action) => {
            state.UpUpdateRequest.zipCode = action.payload
        },
        setUpCity: (state, action) => {
            state.UpUpdateRequest.city = action.payload
        },
        setUpAddress: (state, action) => {
            state.UpUpdateRequest.address = action.payload
        },
        //reset 
        resetGetAllStatus: (state) => {
            state.getAllUpRowsStatus = 'idle'
        },
        resetUpdateStatus: (state) => {
            state.getAllUpRowsStatus = 'idle'
        },
        resetFilters: (state) => {
            state.filtersUp = {
                page: 0,
                itemsPerPage: 0
            }
        }
       
    },
    extraReducers(builder) {
        builder

            .addCase(GetAllUpRows.pending, (state) => {
                state.getAllUpRowsStatus = 'loading'
            })
            .addCase(GetAllUpRows.fulfilled, (state, action) => {
                state.getAllUpRowsStatus = 'successfully'
                state.GetAllUpRowsResponse = action.payload
            })
            .addCase(GetAllUpRows.rejected, (state, action) => {
                state.getAllUpRowsStatus = 'failed'
            })

            .addCase(UpdateUp.pending, (state) => {
                state.UpdateUpStatus = 'loading'
            })
            .addCase(UpdateUp.fulfilled, (state, action) => {
                state.UpdateUpStatus = 'successfully'
            })
            .addCase(UpdateUp.rejected, (state, action) => {
                state.UpdateUpStatus = 'failed'
            })

    }
})

export const {
    setOnEdit,
    setUpAddress,
    setUpCity,
    setUpZipCode,
    resetUpdateStatus,
    resetGetAllStatus
} = NotificationLivestockSlice.actions

export default NotificationLivestockSlice.reducer